import { useState, useEffect } from "react";
import { httpRequest } from "../../../../services/http";
import { apiUrl } from "../../../../common/helpers/Urls";

const useSuggestedData = (variantGenes) => {
  const [suggestedPhenotypes, setSuggestedPhenotypes] = useState([{}]);
  const [hasSuggested, setHasSuggested] = useState(false);
  const [genes, setGenes] = useState([]);
  const [loadingPhenotypes, setLoadingPhenotypes] = useState(false);

  useEffect(() => {
    if (!variantGenes) {
      setLoadingPhenotypes(false);
      return;
    }
    const vGenes = Array.isArray(variantGenes)
      ? variantGenes.map((gene) => gene.symbol)
      : null;
    httpRequest
      .get(`${apiUrl}/gene-diseases-and-phenotypes/${vGenes}`)
      .then((response) => {
        const { data } = response;
        const suggestedPhenotypesByGene = data.filter((sugPhen) => sugPhen.hpo);
        const suggestedGenes = suggestedPhenotypesByGene.map(
          (sugPhen) => sugPhen.gene_symbol
        );
        const sug = [{}];
        let hasSug = false;
        suggestedPhenotypesByGene.forEach((s) => {
          sug[0].diseases = s.hpo[0].diseases || [];
          sug[0].phenotypes = s.hpo[0].phenotypes || [];
          hasSug = true;
        });
        setSuggestedPhenotypes(sug);
        setHasSuggested(hasSug);
        setGenes(suggestedGenes);
      })
      .catch((err) => {
        console.error(
          "Error fetching suggested diseases for this variant ",
          err
        );
      })
      .finally(() => {
        setLoadingPhenotypes(false);
      });
  }, [variantGenes]);

  return { suggestedPhenotypes, hasSuggested, genes, loadingPhenotypes };
};

export default useSuggestedData;
